export const FETCH_ALL_DASHBOARD_DATA =
    "dashboard/dashboard_fetch_all_dashboard_data"
export const DASHBOARD_DATA_SUCCESS = "dashboard/dashboard_fetch_data_success"
export const DASHBOARD_DATA_FAILURE = "dashboard/dashboard_fetch_data_failure"

export const DASHBOARD_FILTER_SET = "dashboard/dashboard_filter_set"
export const DASHBOARD_FILTER_CLEAR = "dashboard/dashboard_filter_clear"
